// @ts-nocheck
import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const HeaderStyle = styled.header`
  background-color: ${props => props.theme.bgColor};
  height: 112px;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: end;
  position: sticky;
  top: 50px;
  z-index: 3;

  .reportingHeader {
    &__container {
      width: 100%;
    }
    &__wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding: 0 0.625rem;
      height: 56px;
    }

    &__backLink {
      display: flex;
      padding-right: 1rem;
      text-decoration: none;

      &Icon {
        color: ${props => props.theme.uiColors?.headerIcon};
        font-size: 18px;
        font-weight: 400;
        height: 15.82px;
        width: 16px;
      }
    }

    &__titleMenu {
      padding: 8px 0;
      display: flex;
      flex-direction: column;

      &Button {
        max-height: 32px;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    &__menu {
      display: flex;
      flex-direction: column;
      padding: 8px 0px;

      & >* {
        justify-content: start;

        &:hover {
          text-decoration: underline;
        }
      }

      i {
        height: 16px;
        width: 20px;
      }

      &Button {
        border-color: ${props => props.theme.uiColors?.headerMenu};
      }
    }

    &__downloadReport {
      display: flex;
      flex-direction: column;
      padding: 8px 0;
      align-items: start;

      i {
        height: 16px;
        width: 16px;
      }
    }

    &__downloadButtons {
      margin-top: 16px;
      display: inline-flex;
      flex-direction: column;
      align-items: start;

      &Button {
        &:hover {
          text-decoration: underline;
        }
      }

      &Last {
        align-items: flex-start;
        border-top: solid 1px ${props => props.theme.uiColors?.headerSeparator};
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding-top: var(--spacing-8);
        margin: var(--spacing-8) auto 0 auto;
        width: 80%;

        &Item {
          width: 100%;
          justify-content: flex-start;

          .buttonWrapper__textWrapper {
            max-width: 150px;
            ${mixins.ellipsis};
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &Geo {
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const HeaderDivider = styled.div`
  width: 80%;
  margin: 8px auto;
  border-top: solid 1px ${props => props.theme.uiColors?.headerSeparator};
`;
